import {message, Spin} from "antd";
import {useState} from "react";
import {LoadingSpinner} from "../../../../../../components/icons/icons";
import {StyledAvatarWrapper} from "./styles";
import {ProfileAvatarImage} from "./avatar-image";
import type {UploadFile, UploadProps} from "antd/es/upload/interface";
import type {UploadChangeParam} from "antd/es/upload";
import {ProfileAvatarUpload} from "./avatar-upload";
import {useQueryClient} from "@tanstack/react-query";
import {LEGACY_PROFILE_QUERY_KEY} from "../../../../../../features/profile/hooks/useProfile";

type AvatarUploadStatus = "idle" | "pending" | "resolved" | "rejected";

export function ProfileAvatarFormFiled() {
  const queryClient = useQueryClient();
  const [avatarUploadStatus, setAvatarUploadStatus] =
    useState<AvatarUploadStatus>("idle");

  const handleAvatarImageChange: UploadProps["onChange"] = (
    info: UploadChangeParam<UploadFile>
  ) => {
    // console.log(info);
    if (info.file.status === "uploading") {
      setAvatarUploadStatus("pending");
      return;
    }
    if (info.file.status === "error") {
      setAvatarUploadStatus("rejected");
      message.error(info.file.response.message);
      return;
    }

    if (info.file.status === "done") {
      // Get this url from response in real world.
      queryClient.invalidateQueries({queryKey: [LEGACY_PROFILE_QUERY_KEY]});
      setAvatarUploadStatus("resolved");
      message.success("Your cover image has been uploaded successfully!");
    }
  };

  return (
    <Spin spinning={avatarUploadStatus === "pending"} indicator={LoadingSpinner}>
      <StyledAvatarWrapper>
        <ProfileAvatarImage />
        <ProfileAvatarUpload onImageChange={handleAvatarImageChange} />
      </StyledAvatarWrapper>
    </Spin>
  );
}
